import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const StyledBox = styled(Box)(({ theme }) => ({
  position: 'relative',
  '& .BDVBGContainer': {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    zIndex: 0,
    height: '100%',
    maxHeight: theme.typography.pxToRem(826),
    opacity: 0.7,
    '&:after': {
      content: '""',
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: 0,
      height: '80%',
      zIndex: 1,
      background: `linear-gradient(to top, ${theme.palette.background.primary} 0%, transparent 100%)`,
    },
  },
  '& .BDVCustomeContainer': {
    position: 'relative',
    zIndex: 3,
    maxWidth: theme.typography.pxToRem(1168),
    [theme.breakpoints.down('lg')]: {
      padding: theme.spacing(0, 3),
    },
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(0, 2),
    },
  },
}));

export default StyledBox;
